<template>
  <div>
    <div class="GeZai_Layer relative">
      <img :src="layer1" :class="$store.getters.hOrV + ' h350'" alt="" />
      <div class="hold-img" :class="$store.getters.hOrV">
        <img src="images/collection/display/rtt.png" v-if="$store.state.artwork.layout == 'TT'" class="h350" alt="" /> 
        <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        <template v-if="$store.getters.isDouble">
          <img
            src="images/collection/display/rtt.png"
            v-if="$store.state.artwork.rightLayout == 'TT'"
            class="h350"
            alt=""
          />
          <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        </template>
      </div>
      <div class="button-img" :class="$store.getters.hOrV" >
        <img src="images/collection/sockets/socket_placeholder.png" v-if="$store.state.artwork.layout == 'SK'" class="h350" alt="" />
        <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        <template v-if="$store.state.artwork.format != 'single'">
          <img
            src="images/collection/sockets/socket_placeholder.png"
            v-if="$store.state.artwork.rightLayout == 'SK'"
            class="h350"
            alt=""
          />
          <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        </template>
        <template v-if="$store.getters.isTriple">
          <img
            src="images/collection/sockets/socket_placeholder.png"
            v-if="$store.state.artwork.tripleRightLayout == 'SK'"
            class="h350"
            alt=""
          />
          <img src="images/collection/sockets/empty.png" v-else class="h350" alt="" />
        </template>
      </div>
      <div class="body-img" :class="$store.getters.hOrV">
        <div
          class="table2"
          :class="{ two: $store.state.artwork.format == 'double',
                    vtwo : $store.state.artwork.format == 'vdouble',
                    three: $store.state.artwork.format == 'triple',
                    vthree: $store.state.artwork.format == 'vtriple' }"
        >
          <div
            class="layer2"
            v-for="(i, index) in layer2"
            :key="index"
            :style="{
              top: i.top + 'mm',
              left: i.left + 'mm',
              width: i.width + 'mm',
              height: i.height + 'mm',
            }"
          >
            <div
              :style="{
                verticalAlign: i.style.alignment,
                color: i.content.color,
              }"
            >
              <i
                v-if="
                  i.style.constrain == 1 ||
                  i.style.constrain == 4 ||
                  i.style.constrain == 5 ||
                  i.style.constrain == 6
                "
                :class="i.content.icon"
                class="iconfont2"
                :style="{ fontSize: ((typeof i.content.iconSize != 'undefined') ? i.content.iconSize : i.iconSize) + 'mm' }"
              ></i>
              <p
                v-if="
                  i.style.constrain == 2 ||
                  i.style.constrain == 3 ||
                  i.style.constrain == 4 ||
                  i.style.constrain == 5 ||
                  i.style.constrain == 7
                "
                class=" "
                :style="{  whiteSpace: 'pre', height: i.textBoxHeight , fontSize: ((typeof i.content.fontSize != 'undefined') ? i.content.fontSize : $store.state.fontSizeMap[i.fontSize]) + 'px', marginTop: offset(i) + 'px' }"
              >{{i.content.textL1}}</p>
              <p
                v-if="i.style.constrain == 3 || i.style.constrain == 5"
                class=" "
                :style="{  whiteSpace: 'pre', height: i.textBoxHeight , fontSize: $store.state.fontSizeMap[i.fontSize] + 'px' }"
              >{{i.content.textL2}}</p>
            </div>
          </div>

          

          <div v-if="$store.state.artwork.format != 'single'">
            <div
              class="layer2 right-side"
              v-for="(i, index) in rightLayer2"
              :key="'right' + index"
              :style="{
                top: i.top + 'mm',
                left: i.left + 'mm',
                width: i.width + 'mm',
                height: i.height + 'mm',
              }"
            >
              <div
                :style="{
                  verticalAlign: i.style.alignment,
                  color: i.content.color,
                }"
              >
                <i
                  v-if="
                    i.style.constrain == 1 ||
                    i.style.constrain == 4 ||
                    i.style.constrain == 5 ||
                    i.style.constrain == 6
                  "
                  :class="i.content.icon"
                  class="iconfont2"
                  :style="{ fontSize: ((typeof i.content.iconSize != 'undefined') ? i.content.iconSize : i.iconSize) + 'mm' }"
                ></i>
                <p
                  v-if="
                    i.style.constrain == 2 ||
                    i.style.constrain == 3 ||
                    i.style.constrain == 4 ||
                    i.style.constrain == 5 ||
                    i.style.constrain == 7
                  "
                  class=" "
                  :style="{  whiteSpace: 'pre', height: i.textBoxHeight , fontSize: ((typeof i.content.fontSize != 'undefined') ? i.content.fontSize : $store.state.fontSizeMap[i.fontSize]) + 'px', marginTop: offset(i) + 'px' }"
                >{{i.content.textL1}}</p>
                <p
                  v-if="i.style.constrain == 3 || i.style.constrain == 5"
                  class=" "
                  :style="{  whiteSpace: 'pre', height: i.textBoxHeight , fontSize: $store.state.fontSizeMap[i.fontSize] + 'px' }"
                >{{i.content.textL2}}</p>
              </div>
            </div>
          </div>

          <div v-if="$store.getters.isTriple">
            <div
              class="layer2"
              v-for="(i, index) in tripleRightLayer2"
              :key="'right' + index"
              :style="{
                top: i.top + 'mm',
                left: i.left + 'mm',
                width: i.width + 'mm',
                height: i.height + 'mm',
              }"
            >
              <div
                :style="{
                  verticalAlign: i.style.alignment,
                  color: i.content.color,
                }"
              >
                <i
                  v-if="
                    i.style.constrain == 1 ||
                    i.style.constrain == 4 ||
                    i.style.constrain == 5 ||
                    i.style.constrain == 6
                  "
                  :class="i.content.icon"
                  class="iconfont2"
                  :style="{ fontSize: ((typeof i.content.iconSize != 'undefined') ? i.content.iconSize : i.iconSize) + 'mm' }"
                ></i>
                <p
                  v-if="
                    i.style.constrain == 2 ||
                    i.style.constrain == 3 ||
                    i.style.constrain == 4 ||
                    i.style.constrain == 5 ||
                    i.style.constrain == 7
                  "
                  class=" "
                  :style="{  whiteSpace: 'pre', height: i.textBoxHeight , fontSize: ((typeof i.content.fontSize != 'undefined') ? i.content.fontSize : $store.state.fontSizeMap[i.fontSize]) + 'px', marginTop: offset(i) + 'px' }"
                >{{i.content.textL1}}</p>
                <p
                  v-if="i.style.constrain == 3 || i.style.constrain == 5"
                  class=" "
                  :style="{  whiteSpace: 'pre', height: i.textBoxHeight , fontSize: $store.state.fontSizeMap[i.fontSize] + 'px' }"
                >{{i.content.textL2}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var tripleRightLayoutMap = {
  triple: {
    L9: [
      { top: 19.5, left: 209.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 237.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 266.2, height: 14.2, width: 14.2 },
      { top: 40.7, left: 209.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 237.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 266.2, height: 14.2, width: 14.2 },
      { top: 61.9, left: 209.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 237.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 266.2, height: 14.2, width: 14.2 },
    ],
    SK: []
  },
  vtriple: {
    L9: [
      { top: 217.1, left: 12.1, height: 14.2, width: 14.2 },
      { top: 217.1, left: 40.1, height: 14.2, width: 14.2 },
      { top: 217.1, left: 68.7, height: 14.2, width: 14.2 },
      { top: 238.3, left: 12.1, height: 14.2, width: 14.2 },
      { top: 238.3, left: 40.1, height: 14.2, width: 14.2 },
      { top: 238.3, left: 68.7, height: 14.2, width: 14.2 },
      { top: 259.5, left: 12.1, height: 14.2, width: 14.2 },
      { top: 259.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 259.5, left: 68.7, height: 14.2, width: 14.2 },
    ],
    SK: []
  }
};
var rightLayoutMap = {
  double : {
    L9: [
      { top: 19.5, left: 110.9, height: 14.2, width: 14.2 },
      { top: 19.5, left: 138.9, height: 14.2, width: 14.2 },
      { top: 19.5, left: 167.5, height: 14.2, width: 14.2 },
      { top: 40.7, left: 110.9, height: 14.2, width: 14.2 },
      { top: 40.7, left: 138.9, height: 14.2, width: 14.2 },
      { top: 40.7, left: 167.5, height: 14.2, width: 14.2 },
      { top: 61.9, left: 110.9, height: 14.2, width: 14.2 },
      { top: 61.9, left: 138.9, height: 14.2, width: 14.2 },
      { top: 61.9, left: 167.5, height: 14.2, width: 14.2 },
    ],
    TT: [
      { top: 14.6, left: 133.4, height: 13.3, width: 11 },
      { top: 14.6, left: 148.3, height: 13.3, width: 11 },
      { top: 28.4, left: 115.2, height: 14.2, width: 14.2 },
      { top: 28.4, left: 167.9, height: 14.2, width: 14.2 },
      { top: 45.9, left: 117.9, height: 14.2, width: 14.2 },
      { top: 45.9, left: 138.9, height: 14.2, width: 14.2 },
      { top: 45.9, left: 160.3, height: 14.2, width: 14.2 },
      { top: 65.9, left: 110.9, height: 14.2, width: 14.2 },
      { top: 65.9, left: 138.9, height: 14.2, width: 14.2 },
      { top: 65.9, left: 167.5, height: 14.2, width: 14.2 },
    ],
    DR: [
      { top: 40.75, left: 139.4, height: 13.5, width: 14.2 },
    ],
    KN: [
      { top: 15.35, left: 111.2, height: 13.5, width: 14.2 },
      { top: 15.35, left: 138.9, height: 13.5, width: 14.2 },
      { top: 15.35, left: 167, height: 13.5, width: 14.2 },

      { top: 32.25, left: 111.2, height: 13.5, width: 14.2 },
      { top: 32.25, left: 138.9, height: 13.5, width: 14.2 },
      { top: 32.25, left: 167, height: 13.5, width: 14.2 },

      { top: 49.25, left: 111.2, height: 13.5, width: 14.2 },
      { top: 49.25, left: 138.9, height: 13.5, width: 14.2 },
      { top: 49.25, left: 167, height: 13.5, width: 14.2 },

      { top: 66.15, left: 111.2, height: 13.5, width: 14.2 },
      { top: 66.15, left: 138.9, height: 13.5, width: 14.2 },
      { top: 66.15, left: 167, height: 13.5, width: 14.2 },
    ],
    N34: [
      { top: 27.5-2.8, left: 112.5, height: 23, width: 15 },
      { top: 27.5-2.8, left: 130.3, height: 23, width: 15 },
      { top: 27.5-2.8, left: 148.1, height: 23, width: 15 },
      { top: 27.5-2.8, left: 166, height: 23, width: 15 },

      { top: 66.15, left: 111.4, height: 13.5, width: 14.2 },
      { top: 66.15, left: 138.9, height: 13.5, width: 14.2 },
      { top: 66.15, left: 167, height: 13.5, width: 14.2 },
    ],
    N35: [
      { top: 29.9-2.83, left: 112.3, height: 18, width: 12 },
      { top: 29.9-2.83, left: 126.3, height: 18, width: 12 },
      { top: 29.9-2.83, left: 140.2, height: 18, width: 12 },
      { top: 29.9-2.83, left: 154.2, height: 18, width: 12 },
      { top: 29.9-2.83, left: 168.2, height: 18, width: 12 },

      { top: 66.15, left: 111.4, height: 13.5, width: 14.2 },
      { top: 66.15, left: 138.9, height: 13.5, width: 14.2 },
      { top: 66.15, left: 167, height: 13.5, width: 14.2 },
    ],
    SK: []
  },
  vdouble : {
    L9: [
      { top: 118.4, left: 12.1, height: 14.2, width: 14.2 },
      { top: 118.4, left: 40.1, height: 14.2, width: 14.2 },
      { top: 118.4, left: 68.7, height: 14.2, width: 14.2 },
      { top: 139.6, left: 12.1, height: 14.2, width: 14.2 },
      { top: 139.6, left: 40.1, height: 14.2, width: 14.2 },
      { top: 139.6, left: 68.7, height: 14.2, width: 14.2 },
      { top: 160.8, left: 12.1, height: 14.2, width: 14.2 },
      { top: 160.8, left: 40.1, height: 14.2, width: 14.2 },
      { top: 160.8, left: 68.7, height: 14.2, width: 14.2 },
    ],
    TT: [
      { top: 113.4, left: 34.5, height: 13.3, width: 11 },
      { top: 113.4, left: 49.5, height: 13.3, width: 11 },
      { top: 127.2, left: 12.4, height: 14.2, width: 14.2 },
      { top: 127.2, left: 69, height: 14.2, width: 14.2 },
      { top: 144.7, left: 19.2, height: 14.2, width: 14.2 },
      { top: 144.7, left: 40.1, height: 14.2, width: 14.2 },
      { top: 144.7, left: 61.5, height: 14.2, width: 14.2 },
      { top: 164.7, left: 12.1, height: 14.2, width: 14.2 },
      { top: 164.7, left: 40.1, height: 14.2, width: 14.2 },
      { top: 164.7, left: 68.7, height: 14.2, width: 14.2 },
    ],
    DR: [
      { top: 146.2 - 6.75, left: 47.5 - 7.1, height: 13.5, width: 14.2 },
    ],
    KN: [
      { top: 120.7 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 120.7 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 120.7 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },

      { top: 137.8 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 137.8 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 137.8 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },

      { top: 154.7 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 154.7 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 154.7 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },

      { top: 171.6 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 171.6 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 171.6 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },
    ],
    N34: [
      { top: 137.8 - 11.5, left: 20.8 - 7.5, height: 23, width: 15 },
      { top: 137.8 - 11.5, left: 38.61 - 7.5, height: 23, width: 15 },
      { top: 137.8 - 11.5, left: 56.47 - 7.5, height: 23, width: 15 },
      { top: 137.8 - 11.5, left: 74.34 - 7.5, height: 23, width: 15 },

      { top: 171.7 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 171.7 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 171.7 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },
    ],
    N35: [
      { top: 137.7 - 9, left: 19.5 - 6, height: 18, width: 12 },
      { top: 137.7 - 9, left: 33.5 - 6, height: 18, width: 12 },
      { top: 137.7 - 9, left: 47.5 - 6, height: 18, width: 12 },
      { top: 137.7 - 9, left: 61.5 - 6, height: 18, width: 12 },
      { top: 137.7 - 9, left: 75.4 - 6, height: 18, width: 12 },

      { top: 171.7 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 171.7 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 171.7 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },
    ],
    SK: []
  },
  triple : {
    SK: []
  },
  vtriple : {
    SK: []
  },
};
var layoutMap = {
  single: {
    L9: [
      { top: 19.5, left: 12.1, height: 14.2, width: 14.2 },
      { top: 19.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 19.5, left: 68.7, height: 14.2, width: 14.2 },
      { top: 40.7, left: 12.1, height: 14.2, width: 14.2 },
      { top: 40.7, left: 40.1, height: 14.2, width: 14.2 },
      { top: 40.7, left: 68.7, height: 14.2, width: 14.2 },
      { top: 61.9, left: 12.1, height: 14.2, width: 14.2 },
      { top: 61.9, left: 40.1, height: 14.2, width: 14.2 },
      { top: 61.9, left: 68.7, height: 14.2, width: 14.2 },
    ],
    TT: [
      { top: 14.6, left: 34.4, height: 13.3, width: 11 },
      { top: 14.6, left: 49.5, height: 13.3, width: 11 },
      { top: 28.4, left: 12.4, height: 14.2, width: 14.2 },
      { top: 28.4, left: 69, height: 14.2, width: 14.2 },
      { top: 45.9, left: 19.2, height: 14.2, width: 14.2 },
      { top: 45.9, left: 40.1, height: 14.2, width: 14.2 },
      { top: 45.9, left: 61.5, height: 14.2, width: 14.2 },
      { top: 65.9, left: 12.1, height: 14.2, width: 14.2 },
      { top: 65.9, left: 40.1, height: 14.2, width: 14.2 },
      { top: 65.9, left: 68.1, height: 14.2, width: 14.2 },
    ],
    CR: [
      { top: 14.75, left: 12.9, height: 13.5, width: 14.2 },
      { top: 40.75, left: 12.9, height: 13.5, width: 14.2 },
      { top: 66.75, left: 12.9, height: 13.5, width: 14.2 },
      { top: 66.75, left: 40.4, height: 13.5, width: 14.2 },
      { top: 66.75, left: 67.9, height: 13.5, width: 14.2 },
      { top: 14.7, left: 54, height: 18, width: 14.2 },
      { top: 45, left: 36, height: 18, width: 14.2 },
      { top: 45, left: 72, height: 18, width: 14.2 },
    ],
    CH: [
      { top: 14.75, left: 12.9, height: 13.5, width: 14.2 },
      { top: 40.75, left: 12.9, height: 13.5, width: 14.2 },
      { top: 66.75, left: 12.9, height: 13.5, width: 14.2 },
      { top: 66.75, left: 40.4, height: 13.5, width: 14.2 },
      { top: 66.75, left: 67.9, height: 13.5, width: 14.2 },
      { top: 14.7, left: 54, height: 18, width: 14.2 },
      { top: 45, left: 36, height: 18, width: 14.2 },
      { top: 45, left: 72, height: 18, width: 14.2 },
    ],
    DR: [
      { top: 40.75-1.7, left: 40.4, height: 13.5, width: 14.2 },
    ],
    KN: [
      { top: 15.35, left: 12.5, height: 13.5, width: 14.2 },
      { top: 15.35, left: 40.1, height: 13.5, width: 14.2 },
      { top: 15.35, left: 68.3, height: 13.5, width: 14.2 },

      { top: 32.25, left: 12.5, height: 13.5, width: 14.2 },
      { top: 32.25, left: 40.1, height: 13.5, width: 14.2 },
      { top: 32.25, left: 68.3, height: 13.5, width: 14.2 },

      { top: 49.25, left: 12.5, height: 13.5, width: 14.2 },
      { top: 49.25, left: 40.1, height: 13.5, width: 14.2 },
      { top: 49.25, left: 68.3, height: 13.5, width: 14.2 },

      { top: 66.15, left: 12.5, height: 13.5, width: 14.2 },
      { top: 66.15, left: 40.1, height: 13.5, width: 14.2 },
      { top: 66.15, left: 68.3, height: 13.5, width: 14.2 },
    ],
    N34: [
      { top: 27.5-2.8, left: 13.3, height: 23, width: 15 },
      { top: 27.5-2.8, left: 31.11, height: 23, width: 15 },
      { top: 27.5-2.8, left: 48.97, height: 23, width: 15 },
      { top: 27.5-2.8, left: 66.84, height: 23, width: 15 },

      { top: 66.15, left: 12.5, height: 13.5, width: 14.2 },
      { top: 66.15, left: 40.1, height: 13.5, width: 14.2 },
      { top: 66.15, left: 68.3, height: 13.5, width: 14.2 },
    ],
    N35: [
      { top: 29.9-2.83, left: 13.5, height: 18, width: 12 },
      { top: 29.9-2.83, left: 27.5, height: 18, width: 12 },
      { top: 29.9-2.83, left: 41.5, height: 18, width: 12 },
      { top: 29.9-2.83, left: 55.5, height: 18, width: 12 },
      { top: 29.9-2.83, left: 69.4, height: 18, width: 12 },

      { top: 66.15, left: 12.5, height: 13.5, width: 14.2 },
      { top: 66.15, left: 40.1, height: 13.5, width: 14.2 },
      { top: 66.15, left: 68.3, height: 13.5, width: 14.2 },
    ],
    SK: []
  },
  double: {
    L9: [
      { top: 19.5, left: 13.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 41.4, height: 14.2, width: 14.2 },
      { top: 19.5, left: 67, height: 14.2, width: 14.2 },
      { top: 40.7, left: 13.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 41.4, height: 14.2, width: 14.2 },
      { top: 40.7, left: 67, height: 14.2, width: 14.2 },
      { top: 61.9, left: 13.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 41.4, height: 14.2, width: 14.2 },
      { top: 61.9, left: 67, height: 14.2, width: 14.2 },
    ],
    TT: [
      { top: 14.6, left: 35.8, height: 13.3, width: 11 },
      { top: 14.6, left: 50.8, height: 13.3, width: 11 },
      { top: 28.4, left: 13.7, height: 14.2, width: 14.2 },
      { top: 28.4, left: 70.3, height: 14.2, width: 14.2 },
      { top: 45.9, left: 20.5, height: 14.2, width: 14.2 },
      { top: 45.9, left: 41.4, height: 14.2, width: 14.2 },
      { top: 45.9, left: 62.8, height: 14.2, width: 14.2 },
      { top: 65.9, left: 13.4, height: 14.2, width: 14.2 },
      { top: 65.9, left: 41.4, height: 14.2, width: 14.2 },
      { top: 65.9, left: 67, height: 14.2, width: 14.2 },
    ],
    DR: [
      { top: 40.75-1.7, left: 40.4, height: 13.5, width: 14.2 },
    ],
    KN: [
      { top: 15.35, left: 12.5, height: 13.5, width: 14.2 },
      { top: 15.35, left: 40.1, height: 13.5, width: 14.2 },
      { top: 15.35, left: 68.3, height: 13.5, width: 14.2 },

      { top: 32.25, left: 12.5, height: 13.5, width: 14.2 },
      { top: 32.25, left: 40.1, height: 13.5, width: 14.2 },
      { top: 32.25, left: 68.3, height: 13.5, width: 14.2 },

      { top: 49.25, left: 12.5, height: 13.5, width: 14.2 },
      { top: 49.25, left: 40.1, height: 13.5, width: 14.2 },
      { top: 49.25, left: 68.3, height: 13.5, width: 14.2 },

      { top: 66.15, left: 12.5, height: 13.5, width: 14.2 },
      { top: 66.15, left: 40.1, height: 13.5, width: 14.2 },
      { top: 66.15, left: 68.3, height: 13.5, width: 14.2 },
    ],
    N34: [
      { top: 27.5-2.8, left: 13.3, height: 23, width: 15 },
      { top: 27.5-2.8, left: 31.11, height: 23, width: 15 },
      { top: 27.5-2.8, left: 48.97, height: 23, width: 15 },
      { top: 27.5-2.8, left: 66.84, height: 23, width: 15 },

      { top: 66.15, left: 12.5, height: 13.5, width: 14.2 },
      { top: 66.15, left: 40.1, height: 13.5, width: 14.2 },
      { top: 66.15, left: 68.3, height: 13.5, width: 14.2 },
    ],
    N35: [
      { top: 29.9-2.83, left: 13.5, height: 18, width: 12 },
      { top: 29.9-2.83, left: 27.5, height: 18, width: 12 },
      { top: 29.9-2.83, left: 41.5, height: 18, width: 12 },
      { top: 29.9-2.83, left: 55.5, height: 18, width: 12 },
      { top: 29.9-2.83, left: 69.4, height: 18, width: 12 },

      { top: 66.15, left: 12.5, height: 13.5, width: 14.2 },
      { top: 66.15, left: 40.1, height: 13.5, width: 14.2 },
      { top: 66.15, left: 68.3, height: 13.5, width: 14.2 },
    ],
    SK: []
  },
  vdouble: {
    L9: [
      { top: 20.9, left: 12.1, height: 14.2, width: 14.2 },
      { top: 20.9, left: 40.1, height: 14.2, width: 14.2 },
      { top: 20.9, left: 68.7, height: 14.2, width: 14.2 },
      { top: 42, left: 12.1, height: 14.2, width: 14.2 },
      { top: 42, left: 40.1, height: 14.2, width: 14.2 },
      { top: 42, left: 68.7, height: 14.2, width: 14.2 },
      { top: 63.3, left: 12.1, height: 14.2, width: 14.2 },
      { top: 63.3, left: 40.1, height: 14.2, width: 14.2 },
      { top: 63.3, left: 68.7, height: 14.2, width: 14.2 },
    ],
    TT: [
      { top: 15.9, left: 34.5, height: 13.3, width: 11 },
      { top: 15.9, left: 49.5, height: 13.3, width: 11 },
      { top: 29.7, left: 12.4, height: 14.2, width: 14.2 },
      { top: 29.7, left: 69, height: 14.2, width: 14.2 },
      { top: 47.2, left: 19.2, height: 14.2, width: 14.2 },
      { top: 47.2, left: 40.1, height: 14.2, width: 14.2 },
      { top: 47.2, left: 61.5, height: 14.2, width: 14.2 },
      { top: 67.2, left: 12.1, height: 14.2, width: 14.2 },
      { top: 67.2, left: 40.1, height: 14.2, width: 14.2 },
      { top: 67.2, left: 68.7, height: 14.2, width: 14.2 },
    ],
    DR: [
      { top: 48.7 - 6.75, left: 47.5 - 7.1, height: 13.5, width: 14.2 },
    ],
    KN: [
      { top: 23.4 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 23.4 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 23.4 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },

      { top: 40.3 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 40.3 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 40.3 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },

      { top: 57.2 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 57.2 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 57.2 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },

      { top: 74.1 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 74.1 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 74.1 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },
    ],
    N34: [
      { top: 40.3 - 11.5, left: 20.8 - 7.5, height: 23, width: 15 },
      { top: 40.3 - 11.5, left: 38.61 - 7.5, height: 23, width: 15 },
      { top: 40.3 - 11.5, left: 56.47 - 7.5, height: 23, width: 15 },
      { top: 40.3 - 11.5, left: 74.34 - 7.5, height: 23, width: 15 },

      { top: 74.1 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 74.1 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 74.1 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },
    ],
    N35: [
      { top: 40.2 - 9, left: 19.5 - 6, height: 18, width: 12 },
      { top: 40.2 - 9, left: 33.5 - 6, height: 18, width: 12 },
      { top: 40.2 - 9, left: 47.5 - 6, height: 18, width: 12 },
      { top: 40.2 - 9, left: 61.5 - 6, height: 18, width: 12 },
      { top: 40.2 - 9, left: 75.4 - 6, height: 18, width: 12 },

      { top: 74.1 - 6.75, left: 19.6 - 7.1, height: 13.5, width: 14.2 },
      { top: 74.1 - 6.75, left: 47.2 - 7.1, height: 13.5, width: 14.2 },
      { top: 74.1 - 6.75, left: 75.4 - 7.1, height: 13.5, width: 14.2 },
    ],
    SK: []
  },
  triple: {
    L9: [
      { top: 19.5, left: 14.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 42.6, height: 14.2, width: 14.2 },
      { top: 19.5, left: 71.2, height: 14.2, width: 14.2 },
      { top: 40.7, left: 14.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 42.6, height: 14.2, width: 14.2 },
      { top: 40.7, left: 71.2, height: 14.2, width: 14.2 },
      { top: 61.9, left: 14.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 42.6, height: 14.2, width: 14.2 },
      { top: 61.9, left: 71.2, height: 14.2, width: 14.2 },
    ],
    TT: [
      { top: 14.6, left: 37, height: 13.3, width: 11 },
      { top: 14.6, left: 52, height: 13.3, width: 11 },
      { top: 28.4, left: 14.9, height: 14.2, width: 14.2 },
      { top: 28.4, left: 71.5, height: 14.2, width: 14.2 },
      { top: 45.9, left: 21.7, height: 14.2, width: 14.2 },
      { top: 45.9, left: 42.6, height: 14.2, width: 14.2 },
      { top: 45.9, left: 64, height: 14.2, width: 14.2 },
      { top: 65.9, left: 14.6, height: 14.2, width: 14.2 },
      { top: 65.9, left: 42.6, height: 14.2, width: 14.2 },
      { top: 65.9, left: 71.2, height: 14.2, width: 14.2 },
    ],
    SK: []
  },
  vtriple: {
    L9: [
      { top: 22.1, left: 12.1, height: 14.2, width: 14.2 },
      { top: 22.1, left: 40.1, height: 14.2, width: 14.2 },
      { top: 22.1, left: 68.7, height: 14.2, width: 14.2 },
      { top: 43.3, left: 12.1, height: 14.2, width: 14.2 },
      { top: 43.3, left: 40.1, height: 14.2, width: 14.2 },
      { top: 43.3, left: 68.7, height: 14.2, width: 14.2 },
      { top: 64.5, left: 12.1, height: 14.2, width: 14.2 },
      { top: 64.5, left: 40.1, height: 14.2, width: 14.2 },
      { top: 64.5, left: 68.7, height: 14.2, width: 14.2 },
    ],
    SK: []
  }
};
import isBigIconMixin from '../../../mixins/isBigIconMixin';

export default {
  name: "AxesPanel",
  mixins: [
    isBigIconMixin
  ],
  data() {
    return {
      styleMap: null,
      frameImgs: {
        yorkBlack: {
          single: { img: "images/collection/faces/gyb_1f.png" },
          double: { img: "images/collection/faces/gyb_2f.png" },
          vdouble: { img: "images/collection/faces/gyb_2f_vertical.png" },
          triple: { img: "images/collection/faces/gyb_3f.png" },
          vtriple: { img: "images/collection/faces/gyb_3f_vertical.png" },
        },
        iceWhite: {
          single: { img: "images/collection/faces/giw_1f.png" },
          double: { img: "images/collection/faces/giw_2f.png" },
          vdouble: { img: "images/collection/faces/giw_2f_vertical.png" },
          triple: { img: "images/collection/faces/giw_3f.png" },
          vtriple: { img: "images/collection/faces/giw_3f_vertical.png" },
        },
        venetianGold: {
          single: { img: "images/collection/faces/gvg_1f.png" },
          double: { img: "images/collection/faces/gvg_2f.png" },
          vdouble: { img: "images/collection/faces/gvg_2f_vertical.png" },
          triple: { img: "images/collection/faces/gvg_3f.png" },
          vtriple: { img: "images/collection/faces/gvg_3f_vertical.png" },
        }
      }
    };
  },
  methods: {
    offset(i) {
      if (i.content.hasTextL2 == false && i.iconSize == 6) {
        if(i.fontSize == 2.5 ) { 
          return 6;
        } 
        if (i.fontSize == 3.5){ 
          return 5;
        }
      }
      
      if (i.content.hasTextL2 == true) {
        if (i.iconSize == 6) {
          if(i.fontSize == 2.5 ) { 
            return -1;
          } else if (i.fontSize == 3.5){ 
            return -4;
          }
        } else if (i.iconSize == 8 && i.fontSize == 2.5) {
          return -6;
        }
        
      }

      return 0;
    }
  },

  mounted() {},

  computed: {
    layer1: function () {
      var img = this.frameImgs[this.$store.state.artwork.frameColor][
        this.$store.state.artwork.format
      ].img;

      return img;
    },
    layer2: function () {
      var layoutList = [];
      for (
        var i = 0;
        i < layoutMap[this.$store.state.artwork.format][this.$store.state.artwork.layout].length;
        i++
      ) {
        var lm = layoutMap[this.$store.state.artwork.format][this.$store.state.artwork.layout][i];
        var content = this.$store.state.artwork.content[i];
        var textBoxHeight = this.$store.state.textBoxHeight[this.$store.state.artwork.fontSize] + 'px';

        if (this.$store.state.artwork.layoutStyle == 'iconDoubleLineText' && content.textL1 == '' && content.textL2 == '') {
          textBoxHeight = 'auto';
        } else if (this.$store.state.artwork.layoutStyle == 'iconSingleLineText' && content.textL1 == '') {
          textBoxHeight = 'auto';
        } else if (this.$store.state.artwork.layout == 'KN' && (i < 9 || i == 10)) {
          textBoxHeight = 'auto';
        } else if (this.$store.state.artwork.layout == 'N34' && i < 4) {
          textBoxHeight = 'auto';
        } else if (this.$store.state.artwork.layout == 'N35' && i < 5) {
          textBoxHeight = 'auto';
        }

        layoutList.push({
          id: i,
          top: lm.top,
          left: lm.left,
          height: lm.height,
          width: lm.width,
          fontSize: this.$store.state.artwork.fontSize,
          textBoxHeight: textBoxHeight,
          iconSize: this.isBigIcon(content) ? this.$store.state.bigIconSize : this.$store.state.artwork.iconSize,
          style: {
            alignment: "middle",
            constrain: this.styleMap[this.$store.state.artwork.type][
              this.$store.state.artwork.layout
            ][this.$store.state.artwork.layoutStyle][i],
          },
          content: content,
        });
      }
      return layoutList;
    },

    rightLayer2: function () {
      var layoutList = [];
      for (
        var i = 0;
        i < rightLayoutMap[this.$store.state.artwork.format][this.$store.state.artwork.rightLayout].length;
        i++
      ) {
        var lm = rightLayoutMap[this.$store.state.artwork.format][this.$store.state.artwork.rightLayout][i];
        var content = this.$store.state.artwork.rightContent[i];
        var textBoxHeight = this.$store.state.textBoxHeight[this.$store.state.artwork.rightFontSize] + 'px';

        if (this.$store.state.artwork.rightLayoutStyle == 'iconDoubleLineText' && content.textL1 == '' && content.textL2 == '') {
          textBoxHeight = 'auto';
        } else if (this.$store.state.artwork.rightLayoutStyle == 'iconSingleLineText' && content.textL1 == '') {
          textBoxHeight = 'auto';
        } else if (this.$store.state.artwork.rightLayout == 'KN' && (i < 9 || i == 10)) {
          textBoxHeight = 'auto';
        } else if (this.$store.state.artwork.rightLayout == 'N34' && i < 4) {
          textBoxHeight = 'auto';
        } else if (this.$store.state.artwork.rightLayout == 'N35' && i < 5) {
          textBoxHeight = 'auto';
        }

        layoutList.push({
          id: i,
          top: lm.top,
          left: lm.left,
          height: lm.height,
          width: lm.width,
          fontSize: this.$store.state.artwork.rightFontSize,
          textBoxHeight: textBoxHeight,
          iconSize: this.isBigIcon(this.$store.state.artwork.rightContent[i]) ? this.$store.state.bigIconSize : this.$store.state.artwork.rightIconSize,
          style: {
            alignment: "middle",
            constrain: this.styleMap[this.$store.state.artwork.type][
              this.$store.state.artwork.rightLayout
            ][this.$store.state.artwork.rightLayoutStyle][i],
          },
          content: this.$store.state.artwork.rightContent[i],
        });
      }
      return layoutList;
    },

    tripleRightLayer2: function () {
      var layoutList = [];
      for (
        var i = 0;
        i < tripleRightLayoutMap[this.$store.state.artwork.format][this.$store.state.artwork.tripleRightLayout].length;
        i++
      ) {
        var lm = tripleRightLayoutMap[this.$store.state.artwork.format][this.$store.state.artwork.tripleRightLayout][i];
        var content = this.$store.state.artwork.tripleRightContent[i];
        var textBoxHeight = this.$store.state.textBoxHeight[this.$store.state.artwork.tripleRightFontSize] + 'px';

        if (this.$store.state.artwork.tripleRightLayoutStyle == 'iconDoubleLineText' && content.textL1 == '' && content.textL2 == '') {
          textBoxHeight = 'auto';
        } else if (this.$store.state.artwork.tripleRightLayoutStyle == 'iconSingleLineText' && content.textL1 == '') {
          textBoxHeight = 'auto';
        } 

        layoutList.push({
          id: i,
          top: lm.top,
          left: lm.left,
          height: lm.height,
          width: lm.width,
          fontSize: this.$store.state.artwork.tripleRightFontSize,
          textBoxHeight: textBoxHeight,
          iconSize: this.isBigIcon(this.$store.state.artwork.tripleRightContent[i]) ? this.$store.state.bigIconSize : this.$store.state.artwork.tripleRightIconSize,
          style: {
            alignment: "middle",
            constrain: this.styleMap[this.$store.state.artwork.type][
              this.$store.state.artwork.tripleRightLayout
            ][this.$store.state.artwork.tripleRightLayoutStyle][i],
          },
          content: this.$store.state.artwork.tripleRightContent[i],
        });
      }
      return layoutList;
    },
  },
  created: function () {
    this.styleMap = this.$store.state.styleMap;
  },
};
</script>

<style scoped>
</style>
